import {
  SetStateAction as Action,
  createContext,
  useContext,
  useEffect,
  useState,
  Dispatch,
  FC,
  ReactNode,
} from "react";
import { getMenu } from "src/shared/setup/API/api";

type IHandleError = { message: string; status?: string };

type AuthContextType = {
  setOpenAside: Dispatch<Action<boolean>>;
  openAside: boolean;
  setOPenAlert: Dispatch<Action<boolean>>;
  openAlert: boolean;
  setMessageAlert: Dispatch<Action<string>>;
  messageAlert: string;
  setStatusAlert: Dispatch<Action<string | undefined>>;
  statusAlert: string | undefined;
  setChangePassword: Dispatch<Action<string>>;
  changePassword: string;

  handleGetAlert({ message, status }: IHandleError): void;
};

const LayoutMainProvider = createContext({} as AuthContextType);

export const LayoutMainProviderContext: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [changePassword, setChangePassword] = useState("password");
  const [messageAlert, setMessageAlert] = useState("");
  const [statusAlert, setStatusAlert] = useState<string | undefined>("");
  const [openAlert, setOPenAlert] = useState(false);

  const [openAside, setOpenAside] = useState<boolean>(() => {
    const open = localStorage.getItem(getMenu);

    if (open === "true") return !!open;
    return false;
  });

  useEffect(
    () => localStorage.setItem(getMenu, JSON.stringify(openAside)),
    [openAside]
  );

  const handleGetAlert = ({ message, status }: IHandleError) => {
    setMessageAlert(message);
    setOPenAlert(true);
    setStatusAlert(status);
  };

  return (
    <LayoutMainProvider.Provider
      value={{
        setChangePassword,
        setMessageAlert,
        setStatusAlert,
        handleGetAlert,
        changePassword,
        setOPenAlert,
        setOpenAside,
        messageAlert,
        statusAlert,
        openAside,
        openAlert,
      }}
    >
      {children}
    </LayoutMainProvider.Provider>
  );
};

export const useLayoutMainContext = (): AuthContextType =>
  useContext(LayoutMainProvider);
